<div fxLayout="row wrap" fxLayoutGap="12px" data-testid="signatures-tab-container">
    @for (item of signers(); track item.signId) {
        <div
            class="p-a m-t cipo--border--lite cipo--border-radius--sm"
            fxLayout="column"
            fxLayoutAlign="center center"
            [attr.data-testid]="'signature-item-' + item.signId">
            @if (item.logo) {
                <cipo-img-base64 [base64]="item.logo" [height]="50" radius="50%" data-testid="signature-logo" />
            } @else {
                <div class="cipo--avatar" data-testid="signature-no-logo">
                    <p class="cipo--text--uppercase">{{ item.userNameInitial ?? item.userName[0] }}</p>
                </div>
            }
            <p class="cipo-text--medium-xl" data-testid="signature-user-name">{{ item.userName }}</p>
            <p data-testid="signature-status">
                {{ "signature." + (item.signed ? "signed" : "notSigned") | translate }}
            </p>
        </div>
    }
</div>
